enum AdminType {
    Videndum = "Videndum",
    External = "External"
}

export default AdminType;